export const autocompleteCustomFilter = {
    customFilter: (itemTitle, queryText, item) => {
      // console.log(item);
      var normalized = item.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
      var queryNormalized = queryText.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "");
      var regex = new RegExp(queryNormalized.replaceAll(' ', '.*'));
      // console.log(normalized, queryNormalized, regex);
      return regex.test(normalized);
    }
};